import * as React from 'react';
import {SFC} from 'react';
import {AuthSignUpFormContainer as Form} from '../auth/sign-up-form-container';
import {AuthButton as Button} from '../auth/button';
import {LANDED, PROMO_CODE, REF_CODE} from '../../utils/config';
import {trackOnce} from '../../utils/tracker';
import './styles.sass';

LANDED
  && trackOnce('landed', {'ref-code': REF_CODE, 'promo': PROMO_CODE, page: 'feedback'});

export const SignUp: SFC<{}> = () => (
  <div className={'sign-up'}>
    <Form
      socialAuthEnabled
      renderButton={props => (<Button color={'violet'} {...props}>Sign Up</Button>)}
    />
  </div>
);
